import React from 'react';
import { FaYoutube, FaInstagram, FaEnvelope } from 'react-icons/fa6';
import compassLogo from '../assets/surthrivaling_compass_logo.png';

const YOUTUBE_URL = 'https://www.youtube.com/@surthrivaling';
const INSTAGRAM_URL = 'https://www.instagram.com/surthrivaling';
const EMAIL = 'hello@surthrivaling.com';

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <img
          src={compassLogo}
          alt=""
          className="footer__logo"
          aria-hidden="true"
        />

        <div className="footer__brand">
          <p className="footer__name">Surthrivaling</p>
          <p className="footer__tagline">
            Two Parts Surviving. One Part Thriving. <br></br>Thoroughly shaken...occasionally stirred.
          </p>
        </div>

        <nav className="footer__nav" aria-label="Footer">
          <a
            href={YOUTUBE_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
          >
            <FaYoutube aria-hidden="true" />
          </a>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram aria-hidden="true" />
          </a>
          <a href={`mailto:${EMAIL}`} aria-label="Email">
            <FaEnvelope aria-hidden="true" />
          </a>
        </nav>

        <p className="footer__copy">
          &copy; 2026 Surthrivaling. Built on the move.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
